import { useMemoizedFn } from "ahooks";
import { MutableRefObject, useEffect, useState } from "react";

export default function useOnceInViewport(ref: MutableRefObject<Element>) {
  // 如果是服务端渲染需要默认展示
  const [state, setState] = useState(typeof window === "undefined");

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        const isIntersecting = entry.isIntersecting;
        if (isIntersecting) {
          observer.disconnect();
        }
        setState(isIntersecting);
      }
    });
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return state;
}

export function useInViewport(
  getTarget: (() => HTMLElement) | MutableRefObject<Element>,
  option: IntersectionObserverInit = {}
) {
  const [isViewport, setIsViewport] = useState(false);

  const getTargetFn = useMemoizedFn(() => {
    if (getTarget && typeof getTarget === "function") {
      return getTarget();
    }

    const targetRef = getTarget as MutableRefObject<Element>;

    if (targetRef?.current) {
      return targetRef.current;
    }
  });

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        const isIntersecting = entry.isIntersecting;
        setIsViewport(isIntersecting);
      }
    }, option || {});

    observer.observe(getTargetFn());

    return () => {
      observer.disconnect();
    };
  }, [getTargetFn, option]);

  return [isViewport];
}
